import Vue from 'vue';
import { Components } from 'formiojs';
import PackageFormsPanel from './PackageFormsPanel.vue';
const Panel = Vue.extend(PackageFormsPanel);

export default class PackageForms extends Components.components.component {
  static schema(...extend) { return super.schema({ type: 'ozgpackageforms', key: 'ozgGlobalPackageForms', input: false }, ...extend); }
  render() { return super.render('<div ref="packageFormsHost"></div>'); }
  attach(element) {
    const result = super.attach(element);
    this.loadRefs(element, { packageFormsHost: 'single' });
    if (this.refs.packageFormsHost) { this.panel?.$destroy(); this.panel = new Panel().$mount(); this.refs.packageFormsHost.appendChild(this.panel.$el); }
    return result;
  }
  detach() { this.panel?.$destroy(); this.panel = null; return super.detach(); }
}
